/* /search · página tradicional: orden al cambiar, filtros abiertos en escritorio, «cargar más» con la
   página en la URL, páginas con «Ir a la página» y «Seguir donde me quedé» (23 oct 2026), vendidas plegadas
   con su cuenta (Section Rendering API, mismo section_id), chips «Afinar» con conteo real (sección
   conteo-busqueda) y respaldo «Parecidas» cuando la búsqueda estricta no da nada (sección parecidas). */
(function () {
  var raiz = document.querySelector('[data-busqueda]');
  if (!raiz) return;
  var sectionId = raiz.dataset.sectionId;
  var form = raiz.querySelector('[data-filtros]');
  var panel = raiz.querySelector('[data-filtros-panel]');
  var orden = raiz.querySelector('[data-orden]');
  var escritorio = window.matchMedia('(min-width: 64rem)');

  // Enlaces viejos con consulta floja (?q=ekans): una sola vez, al modo estricto del parser (12 oct 2026).
  // La página «Parecidas» llega con floja=1 y se queda floja a propósito.
  try {
    var uActual = new URL(window.location.href);
    var qActual = uActual.searchParams.get('q') || '';
    var redirige = false;
    if (raiz.dataset.modo === 'search' && qActual && qActual !== '*' && !/[:"]/.test(qActual) && !uActual.searchParams.get('floja') && window.MoonsParser && window.MoonsParser.interpreta) {
      var rr = window.MoonsParser.interpreta(qActual, []);
      // «one piece», «magic»… solos: a la colección del juego (26 oct 2026)
      if (rr.pagina && rr.pagina.juego) {
        window.location.replace(rr.pagina.url);
        return;
      }
      if (!rr.pagina && rr.q && rr.q !== '*' && rr.q !== qActual) {
        uActual.searchParams.set('q', rr.q);
        Object.keys(rr.filtros || {}).forEach(function (k) { if (!uActual.searchParams.get(k)) uActual.searchParams.set(k, rr.filtros[k]); });
        redirige = true;
      }
    }
    // Sin pestaña en la URL (enlaces de Lo más buscado, de fuera o viejos) la página decía «Disponibles 56» contando
    // también las vendidas (26 oct 2026, gengar: 24 disponibles de 56): se pide la pestaña Disponibles.
    if (raiz.dataset.modo === 'search' && qActual && !uActual.searchParams.has('filter.v.availability') && !uActual.searchParams.get('floja')) {
      uActual.searchParams.set('filter.v.availability', '1');
      redirige = true;
    }
    if (redirige) {
      window.location.replace(uActual.pathname + uActual.search);
      return;
    }
  } catch (err) {}

  // Camino de regreso: la ficha muestra «Volver a …» con esta lista, en la página que se estaba viendo (desde el
  // 23 oct 2026; antes volvía siempre a la primera). La página la actualiza sincroniza() al bajar.
  try {
    var uVolver = new URL(window.location.href);
    uVolver.searchParams.delete('section_id');
    sessionStorage.setItem('moons-volver', JSON.stringify({ u: uVolver.pathname + uVolver.search, e: raiz.dataset.volverEtiqueta || '', n: parseInt(raiz.dataset.conteoTotal, 10) || 0, t: Date.now() }));
  } catch (err) {}

  // Filtros: abiertos en escritorio, plegados en celular
  if (panel) {
    var ajustaPanel = function () { panel.open = escritorio.matches; };
    ajustaPanel();
    escritorio.addEventListener('change', ajustaPanel);
  }

  // Orden: al cambiar, se envía el formulario completo (conserva q y filtros)
  if (orden && form) {
    orden.addEventListener('change', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
  }

  // Precio: no enviar campos vacíos para no ensuciar la URL. Lo escrito es precio público; Shopify filtra
  // por el valor base, así que se convierte al enviar (MoonsParser.aBase, regla de snippets/precios-json).
  if (form) {
    form.addEventListener('submit', function () {
      form.querySelectorAll('input[type="number"]').forEach(function (i) {
        if (!i.value) { i.disabled = true; return; }
        if (!i.closest('[data-precio-publico]') || !window.MoonsParser || !window.MoonsParser.aBase) return;
        var n = parseFloat(i.value);
        if (isNaN(n)) return;
        i.value = String(window.MoonsParser.aBase(n, /\.gte$/.test(i.name) ? 'gte' : 'lte'));
      });
    });
  }

  function conSeccion(url, id) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(id || sectionId);
  }

  function trae(url, id) {
    return fetch(conSeccion(url, id), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }

  // Páginas (23 oct 2026, fallo de Moon: «navegar mejor entre números de página, escoger a qué página ir, pensando
  // en un cliente que ve todo el historial durante varios días»). Cada tarjeta sabe de qué página vino (data-pag);
  // la que pasa por media pantalla decide la página «vista»: va a la URL (recargar o compartir cae ahí), al campo
  // «Página [n]» de arriba y a sus flechas. Las páginas agregadas al bajar llevan su marca «Página n».
  var boton = raiz.querySelector('[data-cargar-mas]');
  var rejilla = raiz.querySelector('[data-rejilla]');
  var progreso = raiz.querySelector('[data-progreso]');
  var porPagina = parseInt(raiz.dataset.porPagina, 10) || 24;
  var paginas = parseInt(raiz.dataset.paginas, 10) || 1;
  var paginaInicial = parseInt(raiz.dataset.pagina, 10) || 1;
  var paginaFinal = paginaInicial;
  var paginaVista = paginaInicial;
  var total = parseInt(raiz.dataset.conteoTotal, 10) || 0;

  function quitaSeccion(href) {
    try {
      var u = new URL(href, window.location.href);
      u.searchParams.delete('section_id');
      return u.pathname + u.search;
    } catch (err) { return href; }
  }

  function urlPagina(n) {
    var u = new URL(window.location.href);
    u.searchParams.delete('section_id');
    if (n <= 1) u.searchParams.delete('page'); else u.searchParams.set('page', String(n));
    return u.pathname + u.search;
  }

  function cifra(n) { return Number(n).toLocaleString('es-MX'); }

  var vigia = null;
  var recorrido = { anota: function () {} };

  function marcaTarjetas(nodos, n) {
    nodos.forEach(function (t) {
      t.setAttribute('data-pag', String(n));
      if (vigia) vigia.observe(t);
    });
  }

  // Flecha de arriba: enlace a la página n, o apagada si no existe
  function ponFlecha(el, n) {
    if (!el) return el;
    var activa = n >= 1 && n <= paginas;
    var etiqueta = activa ? 'a' : 'span';
    var nuevo = el;
    if (el.tagName.toLowerCase() !== etiqueta) {
      nuevo = document.createElement(etiqueta);
      Array.prototype.forEach.call(el.attributes, function (a) { nuevo.setAttribute(a.name, a.value); });
      nuevo.innerHTML = el.innerHTML;
      el.parentNode.replaceChild(nuevo, el);
    }
    if (activa) {
      nuevo.setAttribute('href', urlPagina(n));
      nuevo.removeAttribute('aria-disabled');
    } else {
      nuevo.removeAttribute('href');
      nuevo.setAttribute('aria-disabled', 'true');
    }
    return nuevo;
  }

  function sincroniza() {
    try { history.replaceState(history.state, '', urlPagina(paginaVista)); } catch (err) {}
    try {
      var vv = JSON.parse(sessionStorage.getItem('moons-volver') || 'null');
      if (vv) { vv.u = urlPagina(paginaVista); sessionStorage.setItem('moons-volver', JSON.stringify(vv)); }
    } catch (err) {}
    var arriba = raiz.querySelector('[data-paginador="arriba"]');
    if (!arriba) return;
    var campo = arriba.querySelector('[data-pagina-campo]');
    if (campo && document.activeElement !== campo) campo.value = String(paginaVista);
    ponFlecha(arriba.querySelector('[data-pagina-anterior]'), paginaVista - 1);
    ponFlecha(arriba.querySelector('[data-pagina-siguiente]'), paginaVista + 1);
  }

  if (rejilla && 'IntersectionObserver' in window) {
    vigia = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (!en.isIntersecting) return;
        var n = parseInt(en.target.getAttribute('data-pag'), 10) || paginaInicial;
        if (n !== paginaVista) { paginaVista = n; sincroniza(); }
        recorrido.anota(en.target, n);
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
  }
  if (rejilla) marcaTarjetas(Array.prototype.slice.call(rejilla.querySelectorAll('.tarjeta')), paginaInicial);

  // «Ir a la página»: conserva todo lo que trae la URL (búsqueda, orden, pestaña) y solo cambia la página.
  // Si la página pedida ya está en la rejilla, baja hasta ella en vez de recargar.
  raiz.addEventListener('submit', function (e) {
    var f = e.target.closest ? e.target.closest('[data-ir-pagina]') : null;
    if (!f) return;
    e.preventDefault();
    var campo = f.querySelector('[data-pagina-campo]');
    var n = campo ? parseInt(campo.value, 10) : NaN;
    if (isNaN(n)) { if (campo) campo.focus(); return; }
    n = Math.max(1, Math.min(paginas, n));
    if (campo) campo.value = String(n);
    if (rejilla && n >= paginaInicial && n <= paginaFinal) {
      var destino = n === paginaInicial ? rejilla : rejilla.querySelector('[data-pagina-marca="' + n + '"]');
      if (destino) {
        destino.scrollIntoView({ block: 'start' });
        var primera = n === paginaInicial ? rejilla.querySelector('.tarjeta a') : destino.nextElementSibling && destino.nextElementSibling.querySelector('a');
        if (primera) primera.focus({ preventScroll: true });
        return;
      }
    }
    window.location.href = urlPagina(n);
  });

  // Cargar más: agrega la siguiente página (con su marca), sin repetir piezas que ya estén en la rejilla
  if (boton && rejilla) {
    var automatica = false;
    boton.addEventListener('click', function (e) {
      e.preventDefault();
      if (boton.getAttribute('aria-busy') === 'true') return;
      var porUsuario = !automatica;
      automatica = false;
      boton.setAttribute('aria-busy', 'true');
      var siguiente = boton.getAttribute('href');
      trae(siguiente)
        .then(function (doc) {
          var nueva = doc.querySelector('[data-rejilla]');
          var primero = null;
          var agregadas = [];
          var n = paginaFinal + 1;
          if (nueva) {
            n = parseInt(nueva.dataset.pagina, 10) || n;
            // Recién llegadas por día: si la página siguiente empieza con el mismo día, no se repite el encabezado
            var dias = rejilla.querySelectorAll('.busqueda__dia');
            var ultimoDia = dias.length ? dias[dias.length - 1] : null;
            var diaVisto = false;
            var hay = {};
            Array.prototype.forEach.call(rejilla.querySelectorAll('.tarjeta[data-handle]'), function (t) { hay[t.getAttribute('data-handle')] = true; });
            Array.prototype.forEach.call(nueva.children, function (hijo) {
              if (hijo.classList.contains('busqueda__dia')) {
                var primerDia = !diaVisto;
                diaVisto = true;
                if (primerDia && ultimoDia && hijo.getAttribute('data-dia') === ultimoDia.getAttribute('data-dia')) return;
              }
              if (hijo.classList.contains('tarjeta') && hay[hijo.getAttribute('data-handle')]) return;
              var nodo = document.importNode(hijo, true);
              if (nodo.classList.contains('tarjeta')) {
                agregadas.push(nodo);
                if (!primero) primero = nodo;
              }
              rejilla.appendChild(nodo);
            });
            rejilla.dataset.pagina = String(n);
            paginaFinal = n;
            marcaTarjetas(agregadas, n);
          }
          var proximo = doc.querySelector('[data-cargar-mas]');
          if (proximo) {
            boton.setAttribute('href', quitaSeccion(proximo.getAttribute('href')));
          } else {
            boton.parentElement.removeChild(boton);
          }
          // El paginador de abajo pasa a ser el de la última página cargada
          var abajoNuevo = doc.querySelector('[data-paginador="abajo"]');
          var abajo = raiz.querySelector('[data-paginador="abajo"]');
          if (abajoNuevo && abajo) {
            var copia = document.importNode(abajoNuevo, true);
            Array.prototype.forEach.call(copia.querySelectorAll('a[href]'), function (a) { a.setAttribute('href', quitaSeccion(a.getAttribute('href'))); });
            abajo.parentNode.replaceChild(copia, abajo);
          }
          if (progreso) {
            var desde = parseInt(progreso.dataset.desde, 10) || 1;
            var hasta = Math.min(paginaFinal * porPagina, total);
            var plantilla = progreso.dataset.plantilla || '%1 – %2 / %3';
            progreso.textContent = plantilla.replace('%1', cifra(desde)).replace('%2', cifra(hasta)).replace('%3', progreso.dataset.total || cifra(total));
          }
          if (!vigia) {
            paginaVista = paginaFinal;
            sincroniza();
          }
          if (primero && porUsuario) {
            var enlace = primero.querySelector('a');
            if (enlace) enlace.focus({ preventScroll: true });
          }
        })
        .catch(function () { window.location.href = siguiente; })
        .then(function () { boton.removeAttribute('aria-busy'); });
    });

    // Scroll continuo: al acercarse al botón se carga la siguiente página sola, hasta tres veces seguidas;
    // después vuelve a pedir el clic para que el pie siga siendo alcanzable.
    if ('IntersectionObserver' in window) {
      var automaticas = 0;
      var observador = new IntersectionObserver(function (entradas) {
        if (!entradas[0].isIntersecting) return;
        if (!document.contains(boton)) { observador.disconnect(); return; }
        if (automaticas >= 3 || boton.getAttribute('aria-busy') === 'true') return;
        automaticas += 1;
        automatica = true;
        boton.click();
      }, { rootMargin: '700px 0px' });
      observador.observe(boton);
    }
  }

  // Seguir donde me quedé (23 oct 2026). Cada lista (ruta + búsqueda + pestaña + orden) guarda en este navegador
  // la carta más lejana que se vio. En «Recién llegado» de una colección, lo más lejano es lo más viejo, y se
  // guarda por su fecha de alta: al volver, sections/catalogo-fechas dice cuántas piezas son más nuevas que esa
  // carta hoy, y de ahí sale su página actual aunque hayan entrado cientos (o se hayan vendido otras). En los demás
  // órdenes y en la búsqueda, se guarda el número de página. Nada sale del navegador.
  recorrido = (function () {
    var CLAVE = 'moons:recorridos';
    var VIDA = 90 * 24 * 3600 * 1000;
    var franja = raiz.querySelector('[data-retomar]');
    var porFecha = raiz.dataset.modo === 'collection' && raiz.dataset.orden === 'created-descending';
    var clave = (function () {
      var u = new URL(window.location.href);
      ['page', 'section_id', 'sort_by'].forEach(function (k) { u.searchParams.delete(k); });
      var pares = [];
      u.searchParams.forEach(function (v, k) { pares.push(k + '=' + v); });
      pares.sort();
      return u.pathname + '?' + pares.join('&') + '|' + (raiz.dataset.orden || '');
    })();

    function leeTodos() {
      try { var o = JSON.parse(localStorage.getItem(CLAVE) || '{}'); return o && typeof o === 'object' ? o : {}; } catch (err) { return {}; }
    }
    function guardaTodos(o) {
      try { localStorage.setItem(CLAVE, JSON.stringify(o)); } catch (err) {}
    }

    var todos = leeTodos();
    var guardado = todos[clave] || null;
    // «Todas las cartas» pasó de /collections/disponibles a /collections/pokemon (26 oct 2026): por fecha de alta el
    // lugar sirve igual, así que la primera vez se retoma el de la lista anterior (por página no: las páginas cambian)
    if (!guardado && porFecha && clave.indexOf('/collections/pokemon?') === 0) {
      guardado = todos[clave.replace('/collections/pokemon?', '/collections/disponibles?')] || null;
    }
    if (guardado && Date.now() - (guardado.at || 0) > VIDA) guardado = null;
    var rec = guardado ? JSON.parse(JSON.stringify(guardado)) : null;

    // La visita anterior es la última actividad guardada antes de esta sesión del navegador
    var visitaAnterior = 0;
    try {
      var kv = 'moons:visita:' + clave;
      var v = sessionStorage.getItem(kv);
      if (v === null) { v = String(guardado ? guardado.at || 0 : 0); sessionStorage.setItem(kv, v); }
      visitaAnterior = parseInt(v, 10) || 0;
    } catch (err) {}

    var pendiente = false;
    function guarda() {
      pendiente = false;
      if (!rec) return;
      var o = leeTodos();
      o[clave] = rec;
      var claves = Object.keys(o).sort(function (a, b) { return (o[b].at || 0) - (o[a].at || 0); });
      claves.slice(12).forEach(function (k) { delete o[k]; });
      guardaTodos(o);
    }
    window.addEventListener('pagehide', guarda);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') guarda(); });

    function anota(t, n) {
      var creada = parseInt(t.getAttribute('data-creada'), 10) || 0;
      var r = rec || {};
      var avanza = porFecha ? (creada > 0 && (!r.t || creada < r.t)) : (!r.p || n >= r.p);
      if (avanza) {
        r.t = creada;
        r.p = n;
        r.h = t.getAttribute('data-handle') || '';
        r.n = t.getAttribute('data-nombre') || '';
      }
      r.at = Date.now();
      rec = r;
      if (!pendiente) { pendiente = true; setTimeout(guarda, 1500); }
    }

    // Fechas de alta en bloques de 250 (sections/catalogo-fechas), con caché por bloque
    var bloques = {};
    function bloque(k) {
      if (bloques[k]) return bloques[k];
      var url = window.location.pathname + '?sort_by=created-descending&page=' + k + '&section_id=catalogo-fechas';
      bloques[k] = fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html.match(/data-fechas="([^"]*)" data-bloque="(\d+)" data-bloques="(\d+)" data-total="(\d+)"/);
          if (!m) return null;
          return { ts: m[1] ? m[1].split(',').map(Number) : [], k: parseInt(m[2], 10), cuantos: parseInt(m[3], 10), total: parseInt(m[4], 10) };
        })
        .catch(function () { return null; });
      return bloques[k];
    }

    // Cuántas piezas de la lista son más nuevas que T (segundos). Empieza por el bloque donde estaba la carta;
    // si no, prueba el vecino (lo común: unos días de diferencia) y después parte el rango a la mitad.
    function masNuevasQue(T, estimado, listo) {
      var B = 250;
      var lo = 1, hi = 0, vueltas = 0;
      var k = Math.max(1, Math.floor(estimado / B) + 1);
      function paso() {
        if (++vueltas > 14) { listo(null); return; }
        bloque(k).then(function (d) {
          if (!d) { listo(null); return; }
          hi = hi ? Math.min(hi, d.cuantos) : d.cuantos;
          var ts = d.ts;
          var antes = k;
          if (!ts.length) {
            hi = Math.min(hi, k - 1);
          } else if (ts[ts.length - 1] > T) {
            lo = k + 1;
          } else if (ts[0] <= T) {
            hi = k - 1;
          } else {
            var c = 0;
            while (c < ts.length && ts[c] > T) c++;
            listo((k - 1) * B + c);
            return;
          }
          if (lo > hi) { listo(Math.min((lo - 1) * B, d.total)); return; }
          k = vueltas === 1 ? (lo === antes + 1 ? antes + 1 : antes - 1) : Math.floor((lo + hi) / 2);
          k = Math.max(lo, Math.min(hi, k));
          paso();
        });
      }
      paso();
    }

    function cuando(ms) {
      var seg = Math.max(0, (Date.now() - ms) / 1000);
      var rtf = window.Intl && Intl.RelativeTimeFormat ? new Intl.RelativeTimeFormat('es', { numeric: 'auto' }) : null;
      function f(n, unidad, palabra) { return rtf ? rtf.format(-n, unidad) : 'hace ' + n + ' ' + palabra; }
      if (seg < 3600) return f(Math.max(1, Math.round(seg / 60)), 'minute', 'min');
      if (seg < 86400) return f(Math.round(seg / 3600), 'hour', 'h');
      return f(Math.round(seg / 86400), 'day', 'días');
    }

    // Pone un texto con [marca] y mete en su lugar un nodo (la carta va en negritas, como texto, nunca como HTML)
    function conMarca(plantilla, marca, nodo) {
      var frag = document.createDocumentFragment();
      var partes = plantilla.split(marca);
      partes.forEach(function (p, i) {
        if (i > 0) frag.appendChild(nodo.cloneNode(true));
        frag.appendChild(document.createTextNode(p));
      });
      return frag;
    }

    function pintaFranja(pagina, nuevas) {
      if (!franja || !rec || pagina <= 1) return;
      pagina = Math.min(pagina, paginas);
      var ds = franja.dataset;
      var texto = document.createElement('p');
      texto.className = 'retomar__texto';
      var plantilla = (rec.n ? ds.tTexto : ds.tTextoSin) || '';
      plantilla = plantilla.split('[pagina]').join(cifra(pagina)).split('[cuando]').join(cuando(rec.at || Date.now()));
      var fuerte = document.createElement('strong');
      fuerte.textContent = rec.n || '';
      texto.appendChild(conMarca(plantilla, '[carta]', fuerte));
      if (nuevas && nuevas > 0) {
        var extra = document.createElement('span');
        extra.className = 'retomar__nuevas';
        extra.textContent = ' ' + (nuevas === 1 ? ds.tNueva : (ds.tNuevas || '').split('[n]').join(cifra(nuevas)));
        texto.appendChild(extra);
      }
      var acciones = document.createElement('div');
      acciones.className = 'retomar__acciones';
      var seguir = document.createElement('a');
      seguir.className = 'boton';
      seguir.href = urlPagina(pagina);
      seguir.textContent = ds.tSeguir || 'Seguir';
      seguir.addEventListener('click', function () {
        try { sessionStorage.setItem('moons:ir-a', JSON.stringify({ k: clave, t: rec.t || 0, h: rec.h || '', p: pagina })); } catch (err) {}
      });
      var olvidar = document.createElement('button');
      olvidar.type = 'button';
      olvidar.className = 'retomar__olvidar';
      olvidar.textContent = ds.tOlvidar || '';
      olvidar.addEventListener('click', function () {
        rec = null;
        var o = leeTodos();
        delete o[clave];
        guardaTodos(o);
        franja.hidden = true;
        var primera = rejilla ? rejilla.querySelector('.tarjeta a') : null;
        if (primera) primera.focus({ preventScroll: true });
      });
      acciones.appendChild(seguir);
      acciones.appendChild(olvidar);
      franja.innerHTML = '';
      franja.appendChild(texto);
      franja.appendChild(acciones);
      franja.hidden = false;
    }

    // Llegada desde «Seguir donde me quedé»: marca «Aquí te quedaste» antes de la carta y baja hasta ella
    var ir = null;
    try { ir = JSON.parse(sessionStorage.getItem('moons:ir-a') || 'null'); } catch (err) {}
    if (ir && ir.k === clave && rejilla) {
      try { sessionStorage.removeItem('moons:ir-a'); } catch (err) {}
      var tarjetas = Array.prototype.slice.call(rejilla.querySelectorAll('.tarjeta'));
      var destino = null;
      if (ir.h) destino = tarjetas.filter(function (t) { return t.getAttribute('data-handle') === ir.h; })[0] || null;
      if (!destino && porFecha && ir.t) destino = tarjetas.filter(function (t) { return (parseInt(t.getAttribute('data-creada'), 10) || 0) <= ir.t; })[0] || null;
      if (destino) {
        var aqui = document.createElement('p');
        aqui.className = 'busqueda__aqui';
        aqui.tabIndex = -1;
        aqui.textContent = (franja && franja.dataset.tAqui) || '';
        rejilla.insertBefore(aqui, destino);
        // Salto directo, sin el desplazamiento suave del tema: al abrir la página no tiene sentido animar 2,000 px
        aqui.scrollIntoView({ block: 'start', behavior: 'instant' });
        aqui.focus({ preventScroll: true });
      }
    } else if (rec && rec.p && paginaInicial === 1 && franja) {
      var arranca = function () {
        if (porFecha && rec.t) {
          masNuevasQue(rec.t, (rec.p - 1) * porPagina, function (i) {
            var pagina = i === null ? rec.p : Math.floor(i / porPagina) + 1;
            if (pagina <= 1) return;
            if (visitaAnterior > 0) {
              masNuevasQue(Math.floor(visitaAnterior / 1000), 0, function (n) { pintaFranja(pagina, n); });
            } else {
              pintaFranja(pagina, null);
            }
          });
        } else {
          pintaFranja(rec.p, null);
        }
      };
      if ('requestIdleCallback' in window) requestIdleCallback(arranca, { timeout: 1200 }); else setTimeout(arranca, 300);
    }

    return { anota: anota };
  })();

  // Vendidas: cuenta y contenido con el mismo motor, availability=0
  var vendidas = raiz.querySelector('[data-vendidas]');
  if (vendidas) {
    var urlVendidas = vendidas.dataset.url;
    var conteo = vendidas.querySelector('[data-vendidas-conteo]');
    var contenido = vendidas.querySelector('[data-vendidas-contenido]');
    var cargado = false;
    var docVendidas = null;

    function pintaVendidas() {
      if (cargado || !docVendidas) return;
      cargado = true;
      var nueva = docVendidas.querySelector('[data-rejilla]');
      if (nueva) {
        var copia = document.importNode(nueva, true);
        copia.removeAttribute('data-rejilla');
        contenido.appendChild(copia);
      }
      var mas = document.createElement('a');
      mas.className = 'boton boton--linea';
      mas.href = urlVendidas;
      mas.textContent = vendidas.dataset.textoTodas || 'Ver todas las vendidas';
      contenido.appendChild(mas);
    }

    trae(urlVendidas)
      .then(function (doc) {
        docVendidas = doc;
        var nodo = doc.querySelector('[data-busqueda]');
        var total = nodo ? parseInt(nodo.dataset.conteoTotal, 10) || 0 : 0;
        if (!total) return;
        Array.prototype.forEach.call(document.querySelectorAll('[data-vendidas-conteo]'), function (el) {
          el.textContent = total.toLocaleString('es-MX');
        });
        // Las vendidas viven en la pestaña de arriba; el pliegue de abajo solo aparece cuando no hay disponibles
        var disponibles = parseInt(raiz.dataset.conteoTotal, 10) || 0;
        if (!disponibles) {
          vendidas.hidden = false;
          vendidas.open = true;
          pintaVendidas();
        }
      })
      .catch(function () {});

    vendidas.addEventListener('toggle', function () {
      if (vendidas.open) pintaVendidas();
    });
  }

  // Afinar (12 oct 2026): conteo real de cada chip, pedido en reposo y de uno en uno (la búsqueda de Shopify
  // devuelve 429 si se le pegan muchas peticiones seguidas); caché de 20 min por URL en sessionStorage.
  var afinar = raiz.querySelector('[data-afinar]');
  if (afinar) {
    var chips = Array.prototype.slice.call(afinar.querySelectorAll('[data-afinar-url]'));
    var CACHE = 'moons:afinar';
    var VIDA = 20 * 60 * 1000;
    function leeCache() {
      try { var c = JSON.parse(sessionStorage.getItem(CACHE) || '{}'); return c && typeof c === 'object' ? c : {}; } catch (e) { return {}; }
    }
    function escribeCache(c) {
      try { sessionStorage.setItem(CACHE, JSON.stringify(c)); } catch (e) {}
    }
    function pintaConteo(chip, n) {
      var el = chip.querySelector('[data-afinar-n]');
      if (n === 0) { chip.hidden = true; return; }
      if (el) el.textContent = n >= 1000 ? '1,000+' : n.toLocaleString('es-MX');
    }
    function cierra() {
      if (!afinar.querySelector('[data-afinar-url]:not([hidden])')) afinar.hidden = true;
    }
    function siguiente(i) {
      if (i >= chips.length) { cierra(); return; }
      var chip = chips[i];
      var u = chip.dataset.afinarUrl;
      var cache = leeCache();
      var hit = cache[u];
      if (hit && Date.now() - hit.t < VIDA) { pintaConteo(chip, hit.n); siguiente(i + 1); return; }
      fetch(conSeccion(u, 'conteo-busqueda'), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html.match(/data-conteo="(\d+)"/);
          if (!m) return;
          var n = parseInt(m[1], 10);
          pintaConteo(chip, n);
          cache = leeCache();
          cache[u] = { n: n, t: Date.now() };
          escribeCache(cache);
        })
        .catch(function () {})
        .then(function () { setTimeout(function () { siguiente(i + 1); }, 150); });
    }
    var arranca = function () { siguiente(0); };
    // Filtros agrupados (26 oct 2026, assets/facetas.js): con popover, la barra nueva trae sus cifras y esta fila se
    // esconde; si la barra no puede pintarse, llama a MoonsAfinar.cuenta y se cuentan los chips como siempre.
    window.MoonsAfinar = { cuenta: arranca };
    if (!(afinar.hasAttribute('data-facetas') && 'popover' in HTMLElement.prototype)) {
      if ('requestIdleCallback' in window) requestIdleCallback(arranca, { timeout: 1500 }); else setTimeout(arranca, 400);
    }
  }

  // Juegos (26 oct 2026, Moon: «que los chips de juego cuenten solo las disponibles, como la página»): el chip de la
  // colección abierta trae su número desde Liquid; los demás piden su conteo de disponibles (sección conteo-busqueda
  // sobre la colección con filter.v.availability=1), uno tras otro, con caché de 5 min. Un juego sin disponibles se esconde.
  var juegosN = Array.prototype.slice.call(raiz.querySelectorAll('[data-juego-n]'));
  if (juegosN.length) {
    var CACHE_J = 'moons:juegos';
    var VIDA_J = 5 * 60 * 1000;
    var porUrl = {};
    juegosN.forEach(function (el) {
      var u = el.getAttribute('data-juego-n');
      (porUrl[u] = porUrl[u] || []).push(el);
    });
    var urlsJ = Object.keys(porUrl);
    var leeJ = function () {
      try { var c = JSON.parse(sessionStorage.getItem(CACHE_J) || '{}'); return c && typeof c === 'object' ? c : {}; } catch (e) { return {}; }
    };
    var ponJ = function (u, n) {
      porUrl[u].forEach(function (el) {
        if (n === 0) { var chip = el.closest('.atajo'); if (chip && !chip.hasAttribute('aria-current')) chip.hidden = true; return; }
        el.textContent = n.toLocaleString('es-MX');
      });
    };
    var sigueJ = function (i) {
      if (i >= urlsJ.length) return;
      var u = urlsJ[i];
      var c = leeJ();
      if (c[u] && Date.now() - c[u].t < VIDA_J) { ponJ(u, c[u].n); sigueJ(i + 1); return; }
      fetch(conSeccion(u, 'conteo-busqueda'), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html.match(/data-conteo="(\d+)"/);
          if (!m) return;
          var n = parseInt(m[1], 10);
          ponJ(u, n);
          c = leeJ();
          c[u] = { n: n, t: Date.now() };
          try { sessionStorage.setItem(CACHE_J, JSON.stringify(c)); } catch (e) {}
        })
        .catch(function () {})
        .then(function () { setTimeout(function () { sigueJ(i + 1); }, 120); });
    };
    sigueJ(0);
  }

  // Parecidas: sin resultados estrictos, la búsqueda floja con las palabras sueltas (hasta ocho tarjetas)
  var nada = raiz.querySelector('[data-parecidas-url]');
  if (nada) {
    trae(nada.dataset.parecidasUrl, 'parecidas')
      .then(function (doc) {
        var bloque = doc.querySelector('.parecidas');
        if (!bloque) return;
        var ancla = nada.querySelector('.busqueda__nada-acciones');
        var nodo = document.importNode(bloque, true);
        if (ancla) nada.insertBefore(nodo, ancla); else nada.appendChild(nodo);
      })
      .catch(function () {});
  }
})();
